module.exports = __webpack_public_path__ + "static/devourer-1813bc690225789c285dbc560734f493.jpeg";